const fetchRecursiveMiddleware = ({next, action, dispatch, getState, isSecondRequest}) => {
    const {
        types,
        callAPI,
        shouldCallAPI = () => true,
        externalData = {},
        extraCbs
    } = action;

    if (!callAPI) {
        next(action);
        return;
    }

    if (shouldCallAPI && !shouldCallAPI(getState())) {
        return Promise.resolve(getState());
    }

    const [pendingType, successType, errorType] = types;

    dispatch({
        type: pendingType,
        externalData
    });

    return callAPI()
        .then(response => {
            dispatch({
                type: successType,
                payload: response.message
                    ? {
                        data: [],
                        count: 0
                    }
                    : extraCbs && extraCbs.length
                        ? extraCbs.reduce((acc, next) => next(acc), response)
                        : response,
                externalData
            });
            return Promise.resolve(getState());
        })
        .catch(error => {
            if (!isSecondRequest) {
                fetchRecursiveMiddleware({dispatch, getState, next, action, isSecondRequest: true});
            } else {
                dispatch({
                    type: errorType,
                    error: error.toString(),
                    externalData
                });

                return Promise.reject(error);
            }
        });
};

const createSlimAsyncMiddleware = ({ dispatch, getState }) => {
    return next => action => fetchRecursiveMiddleware({dispatch, getState, next, action});
};

export default [
    createSlimAsyncMiddleware
];
